import React from 'react';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import Radium from 'radium';

import lockReasons from 'globals/lockReasons';

import styles from './styles';
import messages from './messages';
import * as chatAppSelectors from '../../app/ChatApp/selectors';
import * as chatAppActions from '../../app/ChatApp/actions';

export class ChatConversationEndButton extends React.PureComponent {
  handleClick = () => {
    const { requestEndChat, sessionId } = this.props;
    requestEndChat(sessionId);
  };

  render() {
    const { intl, isLocked, sessionId, campaignHasResponse, closedChatEnabled } = this.props;

    if (!closedChatEnabled || isLocked || sessionId === 'new' || campaignHasResponse === false) return null;

    return (
      <div style={styles.wrapper} className="kustomer-app-end-chat-button-container">
        <button onClick={this.handleClick} style={styles.endChatBtn} className="kustomer-app-end-chat-button">
          {intl.formatMessage(messages.end_chat_copy)}
        </button>
      </div>
    );
  }
}

ChatConversationEndButton.propTypes = {
  intl: intlShape.isRequired,
  requestEndChat: React.PropTypes.func.isRequired,
  isLocked: React.PropTypes.bool,
  campaignHasResponse: React.PropTypes.bool,
  closedChatEnabled: React.PropTypes.bool,
  sessionId: React.PropTypes.string,
};

ChatConversationEndButton.defaultProps = {
  isLocked: false,
  campaignHasResponse: undefined,
  closedChatEnabled: false,
  sessionId: '',
};

export const mapStateToProps = state => {
  const closedChatEnabled = chatAppSelectors.getCompanyClosableChatEnabled(state);
  const sessionId = chatAppSelectors.getActiveSessionId(state);
  const campaignHasResponse = chatAppSelectors.selectCampaignMessageIncludesCustomerResponse(state);

  return {
    closedChatEnabled,
    campaignHasResponse,
    sessionId,
    isLocked: chatAppSelectors.isSessionLocked(state, sessionId),
  };
};

export const mapDispatchToProps = dispatch => {
  return {
    requestEndChat: sessionId => {
      const lockReason = lockReasons.CUSTOMER_ENDED;
      dispatch(chatAppActions.markConversationDone(sessionId, lockReason));
    },
  };
};

export const intlComponent = injectIntl(Radium(ChatConversationEndButton));

export default connect(mapStateToProps, mapDispatchToProps)(intlComponent);
